import { render, staticRenderFns } from "./StrengthNecessitiesSelection.vue?vue&type=template&id=fe5e4dfe&scoped=true"
import script from "./StrengthNecessitiesSelection.vue?vue&type=script&lang=js"
export * from "./StrengthNecessitiesSelection.vue?vue&type=script&lang=js"
import style0 from "./StrengthNecessitiesSelection.vue?vue&type=style&index=0&id=fe5e4dfe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe5e4dfe",
  null
  
)

export default component.exports